<template>
<div class="chapter">
<div class="inner_page">
<div class="booksection">
<p class="imagec"><a id="page_4"><img alt="Image" src="images/p4-01.jpg"/></a></p><a id="page_4">
<p class="pbreak"> </p>
</a><h2 class="h2fm"><a id="page_4"></a><a id="page_5">CONTENTS</a></h2><a id="page_5">
<p class="imagec1"><img alt="Image" src="images/p5-01.jpg"/></p>
</a><p class="toc"><a id="page_5"></a><a href="#/Foreword#foreword" id="rforeword">FOREWORD</a></p>
<p class="toc"><a href="#/Part01#pt1" id="rpt1">DOMAINE TEMPIER: THE VINEYARD AND THE PEYRAUDS</a></p>
<p class="toc"><a href="#/Part02#pt2" id="rpt2">THE VIGNERON’S YEAR: SEASONS AND MENUS</a></p>
<p class="toc"><span href="#/Part03#pt3" id="rpt3" title="Link target outside of Sample">LULU’S KITCHEN: RECIPES</span></p>
<p class="toc1"><span href="#/Chapter01#ch1" id="rch1" title="Link target outside of Sample">INTRODUCTION</span></p>
<p class="toc1"><span href="#/Chapter02#ch2" id="rch2" title="Link target outside of Sample">APÉRITIF AND AMUSE-GUEULES</span></p>
<p class="toc1"><span href="#/Chapter03#ch3" id="rch3" title="Link target outside of Sample">PROVENÇAL CELEBRATIONS</span></p>
<p class="toc1"><span href="#/Chapter04#ch4" id="rch4" title="Link target outside of Sample">SOUPS</span></p>
<p class="toc1"><span href="#/Chapter05#ch5" id="rch5" title="Link target outside of Sample">FISH</span></p>
<p class="toc1"><span href="#/Chapter06#ch6" id="rch6" title="Link target outside of Sample">MEATS, POULTRY, GAME</span></p>
<p class="toc1"><span href="#/Chapter07#ch7" id="rch7" title="Link target outside of Sample">VEGETABLES, SALADS, GRAINS, PASTA</span></p>
<p class="toc1"><span href="#/Chapter08#ch8" id="rch8" title="Link target outside of Sample">CHEESES AND DESSERTS</span></p>
<p class="toc"><span href="#/Part04#pt4" id="rpt4" title="Link target outside of Sample">WINE-TASTING NOTES</span></p>
<p class="toc"><span href="#/Index#index" id="rindex" title="Link target outside of Sample">INDEX</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?5a31d890